var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPricing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OBJECT",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750.01407 750",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n      fill: #7c7c7c;\n      }\n\n      .cls-2 {\n      fill: #b2b2b2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "dark",
    className: "cls-1",
    d: "M461.25,227.75l-200-100a24.99995,24.99995,0,0,0-22.5,0l-200,100A25,25,0,0,0,25,250V750a25,25,0,0,0,25,25H450a25,25,0,0,0,25-25V250A25,25,0,0,0,461.25,227.75Z",
    transform: "translate(-25 -25)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "light"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M771.75,545,541.00007,145a25.0001,25.0001,0,0,0-23-12.25L312.25007,145a24.977,24.977,0,0,0-10.51068,2.99469L461.25,227.75A25,25,0,0,1,475,250V743.96269L762.5,579A25,25,0,0,0,771.75,545Z",
    transform: "translate(-25 -25)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 225,
    cy: 275,
    r: 75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275,500H150a25,25,0,0,1,0-50H275a25,25,0,0,1,0,50Z",
    transform: "translate(-25 -25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M350,587.5H150a25,25,0,0,1,0-50H350a25,25,0,0,1,0,50Z",
    transform: "translate(-25 -25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M350,675H150a25,25,0,0,1,0-50H350a25,25,0,0,1,0,50Z",
    transform: "translate(-25 -25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250,275a25,25,0,0,1-25-25V50a25,25,0,0,1,50,0V250A25,25,0,0,1,250,275Z",
    transform: "translate(-25 -25)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricing);
export default __webpack_public_path__ + "static/media/pricing.f019056c.svg";
export { ForwardRef as ReactComponent };